import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFunctions } from 'firebase/functions'
import { getRemoteConfig } from 'firebase/remote-config'
import { getStorage } from 'firebase/storage'
import { getFirestore } from 'firebase/firestore'
import firebaseConfig from '../../google-services-web.json'
import defaultConfig from '~/config'
import { getAuth } from 'firebase/auth'
export { fetchAndActivate, getNumber, getString } from 'firebase/remote-config'
export { onAuthStateChanged, signOut, signInWithCustomToken, getIdTokenResult } from 'firebase/auth'
export {
  collection,
  collectionGroup,
  query,
  where,
  doc,
  getDoc,
  getDocs,
  orderBy,
  onSnapshot,
  queryEqual,
  startAt,
  limit,
  Timestamp,
  setDoc,
  addDoc,
  serverTimestamp,
  updateDoc,
  deleteDoc,
  runTransaction,
  writeBatch,
  getDocFromServer,
} from 'firebase/firestore'
export { setUserId, logEvent, setUserProperties } from 'firebase/analytics'
export { ref, uploadString, getDownloadURL, deleteObject, uploadBytes } from 'firebase/storage'
export { httpsCallable } from 'firebase/functions'

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const firestore = getFirestore(app)
export const functions = getFunctions(app, 'europe-west1')
export const storage = getStorage(app)
export const crashlytics = {}
export const setCrashlyticsUserId = (crashlytics: any, userId: string) => null
export const remoteConfig = getRemoteConfig(app)
remoteConfig.defaultConfig = defaultConfig
export const analytics = getAnalytics(app)
